export default "__VITE_ASSET__f1855674__"